import Image from 'next/image';
import { Fragment } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { FeatureCardType } from '../../../types/content';
import * as S from './styles';

/* eslint-disable-next-line */
type CategoryCardProps = {
  featureCardContent: FeatureCardType;
  hoverColor: string;
};

export function FeatureCard(props: CategoryCardProps) {
  const { description, heading, hoverColor, image } = props.featureCardContent;
  const cardImage = image?.data?.attributes.url ? (
    <div className="flex justify-center h-full w-full hover:opacity-90">
      <Image
        alt="feature image"
        height={300}
        src={image?.data?.attributes.url}
        width={400}
      />
    </div>
  ) : (
    <Fragment />
  );

  return (
    <S.Container hoverColor={hoverColor}>
      {cardImage}
      <div className="p-6 lg:py-10 lg:px-6 hover:text-white group h-full card-content flex flex-col items-center">
        <p className="uppercase text-center text-subtitle lg:text-header6 group-hover:text-white lg:leading-6 card-heading">
          {heading}
        </p>
        <ReactMarkdown
          className="text-caption w-full text-center lg:text-subtitle py-4 overflow-hidden text-ellipsis block break-words"
          rehypePlugins={[rehypeRaw]}
        >
          {description}
        </ReactMarkdown>
      </div>
    </S.Container>
  );
}

export default FeatureCard;
